import _omit from 'lodash/omit';
import { QUERY_PARAMS_FOR_SERP_ONLY } from '../constants';
import { Query } from '../types';

const filterQuery = (query: Query, fields: string[] = []) => {
  return _omit(query, [...QUERY_PARAMS_FOR_SERP_ONLY, ...fields]);
};

export default filterQuery;
